(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bubblu-background"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var blobs = Array.prototype.slice.call(document.querySelectorAll('.bubblu-bg__blob'));
    if (reduce || !blobs.length) return;

    var state = blobs.map(function (el, i) {
      var rect = el.getBoundingClientRect();
      return {
        el: el,
        w: rect.width,
        h: rect.height,
        x: rect.left,
        y: rect.top,
        vx: (i % 2 === 0 ? 1 : -1) * (0.12 + Math.random() * 0.1),
        vy: (i % 3 === 0 ? -1 : 1) * (0.1 + Math.random() * 0.1)
      };
    });

    function tick() {
      var vw = window.innerWidth;
      var vh = window.innerHeight;

      state.forEach(function (b) {
        b.x += b.vx;
        b.y += b.vy;

        if (b.x <= 0) { b.x = 0; b.vx *= -1; }
        if (b.x + b.w >= vw) { b.x = vw - b.w; b.vx *= -1; }
        if (b.y <= 0) { b.y = 0; b.vy *= -1; }
        if (b.y + b.h >= vh) { b.y = vh - b.h; b.vy *= -1; }

        b.el.style.transform = 'translate3d(' + b.x + 'px,' + b.y + 'px,0)';
      });

      window.requestAnimationFrame(tick);
    }

    window.requestAnimationFrame(tick);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bubblu-tokens"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.reveal');

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    if (!reduce) {
      var blobs = document.querySelectorAll('[data-parallax]');
      var ticking = false;
      function onScroll() {
        var y = window.scrollY;
        blobs.forEach(function (b) {
          var speed = parseFloat(b.getAttribute('data-parallax')) || 0.1;
          b.style.transform = 'translateY(' + (y * speed) + 'px)';
        });
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
      }, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
